/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    a: "a",
    ul: "ul",
    li: "li",
    img: "img"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h2, {
    id: "this-is-the-start-of-a-beautiful-friendship-️"
  }, React.createElement(_components.a, {
    href: "#this-is-the-start-of-a-beautiful-friendship-️"
  }, "This is the start of a beautiful friendship ", React.createElement("span", {
    role: "img",
    "aria-label": "love"
  }, "❤️"))), "\n", React.createElement("div", {
    className: "copy-thanks"
  }, "Thanks for signing up to my email list ", React.createElement("span", {
    role: "img",
    "aria-label": "letter"
  }, "💌"), "  You're the best! ", React.createElement("span", {
    role: "img",
    "aria-label": "Horns"
  }, "🤘"), " My robots are sending you a welcome email. Here are some extra bonuses, if you want ", React.createElement("span", {
    role: "img",
    "aria-label": "finger-down"
  }, "👇")), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.img, {
    src: "https://goviral.growthtools.com/images/bullets/1.png",
    alt: "1"
  }), " Free copy of Why Programmers Work at Night ", React.createElement("span", {
    role: "img",
    "aria-label": "owl"
  }, "🦉")), "\n", React.createElement(_components.li, null, React.createElement(_components.img, {
    src: "https://goviral.growthtools.com/images/bullets/2.png",
    alt: "2"
  }), " 29 videos on React Basics ", React.createElement("span", {
    role: "img",
    "aria-label": "film"
  })), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
